import React from 'react';
import { Home, Headphones, LayoutGrid, User } from 'lucide-react'; // LayoutGrid icon trading ke liye behtar hai
import './BottomBar.css';

const BottomBar = ({ activeTab, setActiveTab }) => {
  const tabs = [
    { id: 'home', label: 'Home', icon: <Home size={22} /> },
    { id: 'service', label: 'Service', icon: <Headphones size={22} /> },
    { id: 'trading', label: 'Trading', icon: <LayoutGrid size={22} /> }, // ID ko 'trading' kar diya hai
    { id: 'mine', label: 'Mine', icon: <User size={22} /> }
  ];
 
  return (
    <div className="bottom-nav-container">
      <div className="bottom-bar">
        {tabs.map((tab) => (
          <div 
            key={tab.id} 
            className={`tab-item ${activeTab === tab.id ? 'active' : ''}`}
            onClick={() => setActiveTab(tab.id)}
          >
            <div className="icon-box">
              {tab.icon}
              <span className="ripple"></span>
            </div>
            <span>{tab.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BottomBar;